import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';

import { Descriptions, Result, Skeleton, Typography } from 'antd';

import { useGetUserDetailsQuery } from '../graphql/generated';
import { UserContext } from '../contexts/UserContext';
import { BuildingOutlined } from '../components/MabelIcons';

const ClientOrganizationProfilePage: React.FC = () => {
  const { user } = useContext(UserContext);
  const { data, loading, error } = useGetUserDetailsQuery({
    variables: { user_id: user?.user_id },
  });
  const organization = data?.users_by_pk?.client_organization;
  const dashboards = organization?.dashboards;
  const dashboardCount = Array.isArray(dashboards) ? dashboards.length : 0;

  if (loading) return <Skeleton />;
  if (error)
    return (
      <Result
        status="error"
        title="There was an error retrieving organization details"
        subTitle={error?.message}
      />
    );
  if (!organization)
    return (
      <Result
        status="warning"
        title="No organization profile found"
        subTitle="Your account is not attached to a client organization."
      />
    );

  return (
    <>
      <Helmet>
        <title>Organization Profile | Mabel</title>
      </Helmet>
      <Typography.Title level={3}>
        <BuildingOutlined /> Organization Profile
      </Typography.Title>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="Organization Name">
          {organization.organization_name}
        </Descriptions.Item>
        <Descriptions.Item label="Description">
          {organization.organization_description || 'Not provided'}
        </Descriptions.Item>
        <Descriptions.Item label="Dashboards">
          {dashboardCount}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default ClientOrganizationProfilePage;
